import i18n from "./i18n";

export const tWithKeyAttr = (key, params = {}) => {
  const translated = i18n.t(key, params);

  requestAnimationFrame(() => {
    // const candidates = document.querySelectorAll(`[data-i18n-key="${key}"]`);
    // if (candidates.length === 0) {
    //   const elements = document.querySelectorAll("*");
    //   elements.forEach((el) => {
    //     if ((el.textContent || "").trim() === translated.trim()) {
    //       el.setAttribute("data-i18n-key", key);
    //     }
    //   });
    // }
  });

  return translated;
};
